export default __webpack_public_path__ + "static/media/20.2c3b691a.jpg";